export const TickMarkWithBackgroundIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_26533_13161)">
        <foreignObject
          x="-35.4609"
          y="-35.2803"
          width="106.559"
          height="106.56"
        >
        </foreignObject>
        <g filter="url(#filter0_di_26533_13161)" data-figma-bg-blur-radius="36">
          <circle
            cx="17.8191"
            cy="17.9997"
            r="17.28"
            fill="white"
            fill-opacity="0.7"
            shape-rendering="crispEdges"
          />
        </g>
        <path
          d="M27.1329 10.7995L13.8537 25.4821L8.51429 18.881"
          stroke="url(#paint0_linear_26533_13161)"
          stroke-width="2.16"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_26533_13161"
          x="-35.4609"
          y="-35.2803"
          width="106.559"
          height="106.56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.72" />
          <feGaussianBlur stdDeviation="1.08" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26533_13161"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26533_13161"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.72" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0"
          />
          <feBlend
            mode="plus-lighter"
            in2="shape"
            result="effect2_innerShadow_26533_13161"
          />
        </filter>
        <clipPath
          id="bgblur_1_26533_13161_clip_path"
          transform="translate(35.4609 35.2803)"
        >
          <circle cx="17.8191" cy="17.9997" r="17.28" />
        </clipPath>
        <linearGradient
          id="paint0_linear_26533_13161"
          x1="17.437"
          y1="13.3975"
          x2="20.2182"
          y2="23.7767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#009E82" />
          <stop offset="1" stop-color="#00CA9F" />
        </linearGradient>
        <clipPath id="clip0_26533_13161">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
